import apiPostCall from './apiPost'

const printCallback = (response)=>{
	if(response['result']==='OK')
	{
		//alert('印刷を開始します。')
	}
	else
	{
		alert('エラー')
	}
}

window.printA = async (id, params, device) =>{
	await apiPostCall('print/A1', id, params, null)
	if(device === 'pc') {
		await apiPostCall('print/A1', id, params, null)
	}
	await apiPostCall('print/A2', id, params, null, printCallback)
}

window.printB = (id, params) =>{
	apiPostCall('print/B1', id, params)
	apiPostCall('print/B2', id, params)
}
